import React, { useState } from 'react';

const CircleWiseSwitching = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCircle, setSelectedCircle] = useState('all');
  
  // Sample data for Circle Wise Switching
  const [switchingData, setSwitchingData] = useState([
    {
      id: 1,
      circle: 'UP East',
      operatorName: 'Airtel',
      priority: 1,
      apiProvider: 'API Provider 1',
      status: 'Active',
      lastUpdated: '2025-11-05 10:30 AM'
    },
    {
      id: 2,
      circle: 'UP West',
      operatorName: 'Vodafone',
      priority: 2,
      apiProvider: 'API Provider 2',
      status: 'Active',
      lastUpdated: '2025-11-05 10:15 AM'
    },
    {
      id: 3,
      circle: 'Delhi NCR',
      operatorName: 'Jio',
      priority: 1,
      apiProvider: 'API Provider 1',
      status: 'Active',
      lastUpdated: '2025-11-05 09:45 AM'
    },
    {
      id: 4,
      circle: 'Mumbai',
      operatorName: 'BSNL',
      priority: 3,
      apiProvider: 'API Provider 3',
      status: 'Inactive',
      lastUpdated: '2025-11-04 05:30 PM'
    },
    {
      id: 5,
      circle: 'Maharashtra',
      operatorName: 'Airtel',
      priority: 2,
      apiProvider: 'API Provider 2',
      status: 'Active',
      lastUpdated: '2025-11-05 08:20 AM'
    },
    {
      id: 6,
      circle: 'Gujarat',
      operatorName: 'Vodafone',
      priority: 1,
      apiProvider: 'API Provider 1',
      status: 'Active',
      lastUpdated: '2025-11-05 07:10 AM'
    }
  ]);

  // Get unique circles for filter
  const circles = ['all', ...new Set(switchingData.map(item => item.circle))];

  // Filter data based on search and selected circle
  const filteredData = switchingData.filter(item => {
    const matchesSearch = 
      item.circle.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.operatorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.apiProvider.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesCircle = selectedCircle === 'all' || item.circle === selectedCircle;
    
    return matchesSearch && matchesCircle;
  });

  const handleStatusToggle = (id) => {
    setSwitchingData(switchingData.map(item => 
      item.id === id 
        ? { ...item, status: item.status === 'Active' ? 'Inactive' : 'Active' }
        : item
    ));
  };

  return (
    <div className="container-fluid p-4">
      {/* Page Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1">Circle Wise Switching</h2>
          <p className="text-muted mb-0">Manage switching configuration by operator circles</p>
        </div>
        <button className="btn btn-primary">
          <i className="bi bi-plus-circle me-2"></i>
          Add New Configuration
        </button>
      </div>

      {/* Filters */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Search</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by circle, operator, or API provider..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label">Filter by Circle</label>
              <select
                className="form-select"
                value={selectedCircle}
                onChange={(e) => setSelectedCircle(e.target.value)}
              >
                {circles.map((circle, index) => (
                  <option key={index} value={circle}>
                    {circle === 'all' ? 'All Circles' : circle}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="row mb-4">
        <div className="col-md-3 mb-3">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Total Configurations</h6>
                  <h3 className="mb-0">{switchingData.length}</h3>
                </div>
                <i className="bi bi-gear-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-success text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Active</h6>
                  <h3 className="mb-0">
                    {switchingData.filter(item => item.status === 'Active').length}
                  </h3>
                </div>
                <i className="bi bi-check-circle-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-danger text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Inactive</h6>
                  <h3 className="mb-0">
                    {switchingData.filter(item => item.status === 'Inactive').length}
                  </h3>
                </div>
                <i className="bi bi-x-circle-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-info text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Total Circles</h6>
                  <h3 className="mb-0">{circles.length - 1}</h3>
                </div>
                <i className="bi bi-geo-alt-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Switching Table */}
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Circle</th>
                  <th>Operator</th>
                  <th>Priority</th>
                  <th>API Provider</th>
                  <th>Status</th>
                  <th>Last Updated</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item) => (
                    <tr key={item.id}>
                      <td>#{item.id}</td>
                      <td>
                        <i className="bi bi-geo-alt-fill text-primary me-2"></i>
                        {item.circle}
                      </td>
                      <td>{item.operatorName}</td>
                      <td>
                        <span className={`badge ${
                          item.priority === 1 ? 'bg-success' :
                          item.priority === 2 ? 'bg-warning' :
                          'bg-secondary'
                        }`}>
                          Priority {item.priority}
                        </span>
                      </td>
                      <td>{item.apiProvider}</td>
                      <td>
                        <span className={`badge ${
                          item.status === 'Active' ? 'bg-success' : 'bg-danger'
                        }`}>
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <small className="text-muted">{item.lastUpdated}</small>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm" role="group">
                          <button 
                            className="btn btn-outline-primary"
                            title="Edit"
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button 
                            className={`btn ${
                              item.status === 'Active' ? 'btn-outline-danger' : 'btn-outline-success'
                            }`}
                            onClick={() => handleStatusToggle(item.id)}
                            title={item.status === 'Active' ? 'Deactivate' : 'Activate'}
                          >
                            <i className={`bi ${
                              item.status === 'Active' ? 'bi-toggle-on' : 'bi-toggle-off'
                            }`}></i>
                          </button>
                          <button 
                            className="btn btn-outline-danger"
                            title="Delete"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-5">
                      <i className="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                      <p className="text-muted mb-0">No configurations found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted">
              Showing {filteredData.length} of {switchingData.length} configurations
            </div>
            <div>
              <button className="btn btn-sm btn-outline-primary me-2">
                <i className="bi bi-download me-1"></i>
                Export
              </button>
              <button className="btn btn-sm btn-outline-secondary">
                <i className="bi bi-arrow-clockwise me-1"></i>
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CircleWiseSwitching;

